<h3 mat-dialog-title>{{ 'FileSharing.DialogTitle' | translate }}</h3>
<div mat-dialog-content>
    @if (canDisplayRoles) {
        <mat-form-field class="w-100">
            <mat-select placeholder="{{ 'Login.Role' | translate }}" [formControl]="formGroup.controls['roleId'] | formControl">
                @for (role of roles; track role.id) {
                    <mat-option [value]="role.id" [id]="role.id">
                        {{ role.name }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>
    }
    <div>
        <span>{{ 'FileUpload.SelectFile' | translate }}</span>
        <input type="file" [attr.accept]="allowedMimeTypes.join(',')" (change)="fileSelected($event)" />
    </div>
    <div>
        <sl-datepicker
            [control]="formGroup.controls['expiresByUtc']"
            placeholderKey="FileSharing.ExpiresBy"
            [datePickerFilter]="maxExpirationFilter" />
    </div>
</div>
<div mat-dialog-actions class="float-right">
    <button mat-button [disabled]="isLoading" (click)="cancel()">{{ 'General.Cancel' | translate }}</button>
    <button mat-button [class.spinner]="isLoading" [disabled]="isLoading || !formGroup.valid" (click)="upload()">
        {{ 'FileSharing.Upload' | translate }}
    </button>
</div>
